import { roleObjectMatch } from '../../../../global/helpers/auth-helpers';
import { DefaultQuickActionGroup, QuickActionGroup, QuickActionItem } from '../../../../global/models/quick-actions-model';

export function getDefaultActionsByRole(defaultActionGroups: DefaultQuickActionGroup[], roles: any): QuickActionItem[] {
    let longestMatch = 0;
    let bestMatch: DefaultQuickActionGroup = null;

    for (let i = 0; i < defaultActionGroups?.length; i += 1) {
        const group = defaultActionGroups[i];

        const numberOfMatches = roleObjectMatch(group.rolesMatch, roles);
        if (numberOfMatches > longestMatch) {
            longestMatch = numberOfMatches;
            bestMatch = group;
        }
    }

    return bestMatch?.defaultActions || [];
}

export function FilterDefaultActionsByRoles(defaultActions: QuickActionItem[], roles: string[]) {
    return defaultActions.filter(item => !item.rolesMatch || !!roles.find(role => item?.rolesMatch?.includes(role)));
}


export function getAllQuickActions(defaultQuickActions: QuickActionItem[], quickActionGroups: QuickActionGroup[], roles: any): QuickActionItem[] {
    let allQuickActions = defaultQuickActions || [];

    for (let i = 0; i < quickActionGroups?.length; i += 1) {
        const groupItems = quickActionGroups[i]?.quickActionItems?.filter(item => {
            // filter out items that don't pass roles match or are already in the defaults
            return roleObjectMatch(item.rolesMatch, roles) > 0
                && !defaultQuickActions?.some(defaultItem => defaultItem.actionName?.toLowerCase().trim() === item.actionName?.toLowerCase().trim());
        });

        if (groupItems?.length > 0) {
            allQuickActions = allQuickActions.concat(groupItems);
        }
    }

    return allQuickActions;
}

export function getCombinedGroups(defaultQuickActions: QuickActionItem[], quickActionGroups: QuickActionGroup[], roles: any): QuickActionGroup[] {

    const groupMap = new Map<string, QuickActionGroup>();

    // adds all explicit groups to map
    for (let i = 0; i < quickActionGroups?.length; i += 1) {
        const group = quickActionGroups[i];

        // only add group if there are items within the group to add
        const matchedGroupActions = group.quickActionItems?.filter(item => roleObjectMatch(item.rolesMatch, roles) > 0);
        if (matchedGroupActions?.length > 0) {
            const filteredGroup: QuickActionGroup = {
                ...group,
                quickActionItems: matchedGroupActions,
            };
            groupMap.set(group.groupName?.trim().toLowerCase(), filteredGroup);
        }
    }

    // goes through default actions, and adds each to the corresponding group. Otherwise, creates a new group
    for (let i = defaultQuickActions?.length - 1; i >= 0; i -= 1) {
        const defaultAction = defaultQuickActions[i];
        const keyName = defaultAction?.groupName?.trim().toLowerCase();

        const mapping = groupMap.get(keyName);
        if (mapping) {
            // add defaults to front of list if group already exists
            groupMap.set(keyName, {
                ...mapping,
                quickActionItems: [defaultAction, ...mapping.quickActionItems],
            });
        } else {
            // otherwise create new group
            groupMap.set(keyName, {
                groupName: defaultAction.groupName,
                quickActionItems: [defaultAction],
            } as QuickActionGroup);
        }

    }

    return Array.from(groupMap, ([, value]) => value);
}

// filters out items that are saved in local storage but not longer in Episerver
export function filterRemovedActions(selectedQuickActions: QuickActionItem[], allQuickActions: QuickActionItem[]) {
    if (!selectedQuickActions) return [];

    return selectedQuickActions.filter(selected => allQuickActions.some(item => item.id === selected.id));
}